module.exports = __webpack_public_path__ + "img/sz.8f0d2436.svg";